/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleSearchConsoleCannibalizationRowData
 */
export interface GoogleSearchConsoleCannibalizationRowData {
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleCannibalizationRowData
     */
    query?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleSearchConsoleCannibalizationRowData
     */
    pageCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleSearchConsoleCannibalizationRowData
     */
    pages?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleCannibalizationRowData
     */
    clicks?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleCannibalizationRowData
     */
    impressions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleCannibalizationRowData
     */
    ctr?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleCannibalizationRowData
     */
    position?: string;
}

/**
 * Check if a given object implements the GoogleSearchConsoleCannibalizationRowData interface.
 */
export function instanceOfGoogleSearchConsoleCannibalizationRowData(value: object): value is GoogleSearchConsoleCannibalizationRowData {
    return true;
}

export function GoogleSearchConsoleCannibalizationRowDataFromJSON(json: any): GoogleSearchConsoleCannibalizationRowData {
    return GoogleSearchConsoleCannibalizationRowDataFromJSONTyped(json, false);
}

export function GoogleSearchConsoleCannibalizationRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleCannibalizationRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'] == null ? undefined : json['query'],
        'pageCount': json['pageCount'] == null ? undefined : json['pageCount'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'ctr': json['ctr'] == null ? undefined : json['ctr'],
        'position': json['position'] == null ? undefined : json['position'],
    };
}

export function GoogleSearchConsoleCannibalizationRowDataToJSON(json: any): GoogleSearchConsoleCannibalizationRowData {
    return GoogleSearchConsoleCannibalizationRowDataToJSONTyped(json, false);
}

export function GoogleSearchConsoleCannibalizationRowDataToJSONTyped(value?: GoogleSearchConsoleCannibalizationRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'query': value['query'],
        'pageCount': value['pageCount'],
        'pages': value['pages'],
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'ctr': value['ctr'],
        'position': value['position'],
    };
}

